(ns rothko.editor.punctuation.component)

(defn token
  [{:keys [token]}]
  [:span.editor__punctuation
   (:word token)])
